import React, { useContext } from 'react';
import { FormContext } from '../Form';
import { FormField, ValidityProps } from '../FormField';
import styled from 'styled-components/macro';
import { inputStyles } from './inputStyles';

type Props = {
  labelIcon?: React.ReactNode;
  onChange?: (newValue: string) => void;
  onInput?: () => void;
  disabled?: boolean;
  name: string;
  label: string | React.ReactNode;
  className?: string;
  testId?: string;
  isSmall?: boolean;
};

export const DateInputField = ({ name, label, labelIcon, className, testId, disabled, onInput, onChange }: Props) => {
  const formIsDisabled = useContext(FormContext).isDisabled;

  return (
    <FormField name={name} label={label} labelIcon={labelIcon} className={className}>
      {({ field, form, $isValid, $isInvalid }) => (
        <>
          <DateInput
            type="date"
            {...field}
            data-testid={testId || dateInputFieldTestId}
            disabled={form.isSubmitting || formIsDisabled || disabled}
            onChange={changeEvent => {
              field.onChange(changeEvent);

              onChange?.(changeEvent.target.value);
            }}
            onInput={() => {
              onInput?.();
            }}
            $isValid={$isValid}
            $isInvalid={$isInvalid}
          />
        </>
      )}
    </FormField>
  );
};

const DateInput = styled.input<ValidityProps & { isSmall?: boolean }>`
  ${({ $isValid, $isInvalid, isSmall }) => inputStyles({ $isValid, $isInvalid, $isSmall: isSmall })};
`;

const dateInputFieldTestId = 'date-input-field';
